import Vue from 'vue';
import API from '@/api';
import moment from 'moment';
import * as types from '@/store/mutationTypes';
import _ from 'lodash';

const state = {
  companyId: null,
  list: [],
  loadingLoads: false,
  timestamp: null,
};

const getters = {
  list: qbState => qbState.list,
  companyId: qbState => qbState.companyId,
  timestamp: qbState => qbState.timestamp,
  loadingLoads: qbState => qbState.loadingLoads,
};

const mutations = {
  // https://vuejs.org/v2/guide/reactivity.html#Change-Detection-Caveats
  // https://vuejs.org/v2/guide/list.html#Caveats
  [types.SET_PLANNED_LOADS](loadState, { loads, companyId, loading }) {
    loadState.list = loads; // eslint-disable-line no-param-reassign
    loadState.companyId = companyId;// eslint-disable-line no-param-reassign
    loadState.loadingLoads = loading; // eslint-disable-line no-param-reassign
    loadState.timestamp = moment(); // eslint-disable-line no-param-reassign
  },
  [types.UPDATE_PLANNED_LOAD](loadState, loadData) {
    const loadIndex = _.findIndex(loadState.list,
      load => load.humanId === loadData.humanId);
    Vue.set(loadState.list, loadIndex, loadData);
  },
};

const actions = {
  async getPlannedLoads({ commit, dispatch }, companyId) {
    try {
      commit(types.SET_PLANNED_LOADS, { loads: [], companyId, loading: true });
      const response = await API.company.getPlannedLoads({ companyId });
      commit(types.SET_PLANNED_LOADS, { loads: response.data.items, companyId, loading: false });
    } catch (error) {
      dispatch('applications/setErrorNotification', {
        message: error.message,
      }, { root: true });
    }
  },
  updateLoad({ commit }, load) {
    commit(types.UPDATE_PLANNED_LOAD, load);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
};



// WEBPACK FOOTER //
// ./src/store/modules/plannedLoads.js